import angular from 'angular';
import template from './template.html';
import './style.scss';
import './edit-email-list';

export class SelectCandidateEmails {
    candidatesEmailList = [];

    candidateEmailListChanged = candidateEmailList => this.onCandidateEmailListChanged({ candidateEmailList });
}

export const selectCandidateEmailsConfiguration = {
    template,
    bindings: {
        candidatesEmailList: '<',
        onCandidateEmailListChanged: '&',
        onNext: '&',
        onClose: '&',
    },
    controller: SelectCandidateEmails,
    controllerAs: 'selectCandidateEmailsCtrl',
};

angular.module('TALENYA-FE').component('selectCandidateEmails', selectCandidateEmailsConfiguration);